import { useMemo } from 'react'
import { useTenantSettings } from 'react-common'

const defaultLearnerNavigationVisibility: LearnerNavigationVisibilitySettings = {
  catalog: true,
  rooms: false,
  researchProjects: false,
  knowledgeModels: false,
}

type LearnerNavigationVisibilitySettings = {
  catalog?: boolean
  rooms?: boolean
  calendar?: boolean
  researchProjects?: boolean
  knowledgeModels?: boolean
}
export const useLearnerNavigationVisibilitySettings = () => {
  const staticNavigationItems = useTenantSettings<LearnerNavigationVisibilitySettings>('ui.learner.navigation', true)

  const learnerNavigationVisibilitySettings = useMemo(() => {
    return {
      ...defaultLearnerNavigationVisibility,
      ...staticNavigationItems,
    }
  }, [staticNavigationItems])

  return learnerNavigationVisibilitySettings
}
